import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { QineticNegotiationApi } from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const confirmOffer = createAsyncThunk<string, string, ThunkApi>(
  "confirmOffer",
  async (offerId, { rejectWithValue }) => {
    try {
      await new QineticNegotiationApi().confirmOffer(offerId);

      return offerId;
    } catch (err: any) {
      pushErrorMonitor(err); //send error push monitor
      const error: LayoutError = {
        title: "Conferma offerta",
        description:
          "Non siamo riusciti a confermare la tua offerta.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
